import * as betprofessor from './Keypad.styles.betprofessor';
import * as betroyale from './Keypad.styles.betroyale';
import * as goldenrush from './Keypad.styles.goldenrush';
import * as juicybet from './Keypad.styles.juicybet';
import * as puntcity from './Keypad.styles.puntcity';
import * as junglebet from './Keypad.styles.junglebet';
import * as questbet from './Keypad.styles.questbet';
import * as vikingbet from './Keypad.styles.vikingbet';
import * as volcanobet from './Keypad.styles.volcanobet';
import * as wellbet from './Keypad.styles.wellbet';
import * as fiestabet from './Keypad.styles.fiestabet';
import * as oldgill from './Keypad.styles.oldgill';
import * as sugarcastle from './Keypad.styles.sugarcastle';
import * as betgalaxy from './Keypad.styles.betgalaxy';
import * as puntgenie from './Keypad.styles.puntgenie';
import * as sterlingparker from './Keypad.styles.sterlingparker';
import * as buffalobet from './Keypad.styles.buffalobet';
import * as titanbet from './Keypad.styles.titanbet';
import * as templebet from './Keypad.styles.templebet';
import * as slambet from './Keypad.styles.slambet';
import * as gigabet from './Keypad.styles.gigabet';
import * as goldenbet888 from './Keypad.styles.goldenbet888';
import * as betstride from './Keypad.styles.betstride';
import * as hyperbet from './Keypad.styles.hyperbet';
import * as bet777 from './Keypad.styles.bet777';
import * as chromabet from './Keypad.styles.chromabet';
import * as bet575 from './Keypad.styles.bet575';
import * as epicodds from './Keypad.styles.epicodds';
import * as magnumbet from './Keypad.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  buffalobet,
  sterlingparker,
  puntgenie,
  betgalaxy,
  betprofessor,
  betroyale,
  goldenrush,
  juicybet,
  junglebet,
  puntcity,
  questbet,
  vikingbet,
  volcanobet,
  wellbet,
  fiestabet,
  oldgill,
  sugarcastle,
  titanbet,
  templebet,
  slambet,
  gigabet,
  goldenbet888,
  betstride,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  magnumbet,
};
